import React from 'react'
import { Typography } from '@material-ui/core'
import { useSelector } from 'react-redux'
import { myNameSelector } from '../selectors'

const JonathanGee = () => {
	const name = useSelector(myNameSelector);

	return (
		<Typography variant='subtitle1'component='div' >
			{name}
		</Typography>
	);
}

export { JonathanGee };
